import React from 'react';
import d3    from 'd3';

export default class Axis extends React.Component {
    componentDidUpdate() {
        this.renderAxis();
    }

    componentDidMount() {
        this.renderAxis();
    }

    renderAxis() {
        var node  = this.refs.axis;
        var axis = d3.svg.axis()
            .orient(this.props.orient)
            .scale(this.props.scale)
            .tickValues(this.props.ticks)
        if(this.props.tickWidth) {
            axis = axis.tickSize(this.props.tickWidth,0);
        }
        if(this.props.tickFormat) {
            axis = axis.tickFormat(this.props.tickFormat);
        }
        d3.select(node).call(axis);
        if(this.props.translateNumbers) {
            d3.select(node).selectAll(".tick text")
                .attr("transform",`translate(${this.props.translateNumbers[0]},${this.props.translateNumbers[1]})`);
        }
        if(this.props.translateTicks) {
            d3.select(node).selectAll(".tick > *")
                .attr("transform",`translate(${this.props.translateTicks[0]},${this.props.translateTicks[1]})`);
        }
        if(this.props.numberAnchor) {
            d3.select(node).selectAll(".tick text")
                .style("text-anchor",this.props.numberAnchor);
        }
        if(this.props.zeroClass) {
            d3.select(node).selectAll(".tick")
                .classed(this.props.zeroClass,
                    (d) => {
                        return d===0;     
                    }
                );
        }
        
    }

    render() {
        
        return <g 
            className="axis"
            ref="axis"
            transform={this.props.translate}
            style={{display:this.props.hideAxis?"none":"initial"}}    
        />
    }
}


// WEBPACK FOOTER //
// ./src/js/components/charting/Axis/Axis.jsx